/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type SystemComponentsCardVehicleFragment = {
  __typename?: 'Vehicle'
  id: string
  latestADTelemetry: {
    __typename?: 'ADTelemetry'
    signalConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
    cabinConnectivityState: {
      __typename?: 'ADConnectivityStateWithTimestamp'
      connectivityState: Types.AdConnectivityState
      timestamp: string
    } | null
  } | null
}

export const SystemComponentsCardVehicleFragmentDoc = gql`
    fragment SystemComponentsCardVehicle on Vehicle {
  id
  latestADTelemetry {
    signalConnectivityState {
      connectivityState
      timestamp
    }
    cabinConnectivityState {
      connectivityState
      timestamp
    }
  }
}
    `
